"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartPaymentResponseDto } from "@sticker-giant/sg-frontend-common";
import { PaymentMethodType } from "@sticker-giant/sg-frontend-common";
import { useQueryClient } from "@tanstack/react-query";
import { SavedInfoSource } from "@/constants/SavedInfoSource";
import { trackPaymentMethodSaved } from "@/lib/analytics/segment";
import { mapFinalizeResponse } from "@/lib/payment/finalize";
import { paymentProfilesQueryKey } from "@/queries/usePaymentProfiles";
import { useAuthClaimsStore } from "@/stores/useAuthClaimsStore";
import { usePaymentMutation } from "./usePaymentMutation";
export const finalizeCreditCardMutationKey = ["finalizeCreditCard"] as const;
type FinalizeCreditCardInput = {
  paymentProfileId?: string;
  paymentToken?: string;
  recaptchaToken: string;
  savePaymentMethod?: boolean;
};
export function useFinalizeCreditCardPayment() {
  const $ = _c(3);
  const queryClient = useQueryClient();
  const customerId = useAuthClaimsStore(_temp);
  let t0;
  if ($[0] !== customerId || $[1] !== queryClient) {
    t0 = {
      mutationKey: finalizeCreditCardMutationKey,
      method: _temp2,
      onSuccess: (response, t1) => {
        const {
          savePaymentMethod: savePaymentMethod_0
        } = t1;
        if (savePaymentMethod_0 && mapFinalizeResponse(response).kind === "success") {
          trackPaymentMethodSaved(SavedInfoSource.CHECKOUT);
          queryClient.invalidateQueries({
            queryKey: paymentProfilesQueryKey(customerId)
          });
        }
      }
    };
    $[0] = customerId;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return usePaymentMutation(t0);
}
function _temp2(cartClient, cartId, t0) {
  const {
    paymentProfileId,
    paymentToken,
    recaptchaToken,
    savePaymentMethod
  } = t0;
  return cartClient.postFinalizeCreditCardPayment({
    cartId,
    paymentProfileId,
    paymentToken,
    recaptchaToken,
    savePaymentMethod,
    paymentType: PaymentMethodType.CREDIT_CARD
  });
}
function _temp(state) {
  return state.claims?.sg_customer_id;
}